export const blockIconsPhotoandimageBrushNew = (
	<span className='material-symbols-outlined'>brush</span>
);
